export function transformFolders(folders, level = 0) {
  return (folders || []).map((f) => ({
    id: f.id,
    name: f.folderName,
    level,
    folderDescription: f.folderDescription,
    parentFolderId: f.parentFolderId,
    folderPath: f.folderPath,
    individualcount: f.fileCount ?? 0,
    totalcount: f.totalFileCount ?? 0,
    children: Array.isArray(f.subfolders) ? transformFolders(f.subfolders, level + 1) : [],
  }));
}

export function findFolderById(folders, id) {
  for (const f of folders) {
    if (f.id === id) return f;
    if (Array.isArray(f.subfolders)) {
      const found = findFolderById(f.subfolders, id);
      if (found) return found;
    }
  }
  return null;
}

export function flattenFolders(folders, acc = [], level = 0) {
  for (const f of folders || []) {
    acc.push({ ...f, level });
    if (Array.isArray(f.subfolders)) flattenFolders(f.subfolders, acc, level + 1);
  }
  return acc;
}

export function getDescendantIds(folderId, rawFolders) {
  const root = findFolderById(rawFolders, folderId);
  const ids = new Set([folderId]);
  function collect(subs) {
    for (const sf of subs || []) {
      ids.add(sf.id);
      collect(sf.subfolders);
    }
  }
  if (root) collect(root.subfolders);
  return ids;
}

export function formatFileSize(bytes) {
  if (bytes == null || typeof bytes !== 'number' || bytes < 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function getExtension(fileName) {
  return fileName?.split('.').pop()?.toUpperCase() || '';
}

/** Split full filename "report.pdf" into { namePart: "report", extension: "pdf" }. For edit modal: only name is editable. */
export function splitFileName(fullName) {
  if (!fullName || typeof fullName !== 'string') return { namePart: '', extension: '' };
  const t = fullName.trim();
  const lastDot = t.lastIndexOf('.');
  if (lastDot <= 0 || lastDot === t.length - 1) return { namePart: t, extension: '' };
  return {
    namePart: t.slice(0, lastDot),
    extension: t.slice(lastDot + 1).toLowerCase(),
  };
}

/** Display name for a file: uses table file_name (exposed as fileName in API). */
export function getDisplayFileName(file) {
  if (!file) return '';
  return file.fileName ?? file.file_name ?? '';
}
